export const ONHAND_EMAIL_DOMAIN = '@beonhand.co.uk'
